import cs from "classnames";
import React from "react";
import { useTranslation } from "react-i18next";

import "./OOSIndicator.scss";

interface IOOSIndicatorProps {
	"data-testid"?: string;
	className?: string;
}

const OOSIndicator = (props: IOOSIndicatorProps) => {
	const { t } = useTranslation();

	return (
		<div className={cs("OOSIndicator", props.className)} data-testid={props["data-testid"]}>
			{t("productListPage.outOfStock")}
		</div>
	);
};

export default OOSIndicator;
